import { Typography } from 'antd';

import styles from './CreateTaskContent.module.scss';

export default function FormItemTitle({ children }: { children: React.ReactNode }) {
  return (
    <Typography.Text
      strong
      className={styles.formItemTitle}
    >
      {children}
    </Typography.Text>
  );
}
